import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  selectTeamAccounts,
  selectTeamAccountsInitialLoading,
  selectTeamAccountsLoading,
  selectTeamAccountsState,
  useFetchTeamAccountsQuery,
  useLazyFetchTeamAccountsQuery,
} from '../fetchTeamAccounts';

export interface UseTeamAccountsQueryProps extends IUseQueryProps {}

export const useTeamAccountsQuery = ({
  skipFetching,
}: UseTeamAccountsQueryProps = {}) => {
  useFetchTeamAccountsQuery(
    getQueryParams({ params: undefined, skipFetching }),
  );

  const [handleFetchTeamAccounts] = useLazyFetchTeamAccountsQuery();

  const teamAccounts = useAppSelector(selectTeamAccounts);

  const initialLoading = useAppSelector(selectTeamAccountsInitialLoading);

  const loading = useAppSelector(selectTeamAccountsLoading);

  const state = useAppSelector(selectTeamAccountsState);

  return {
    handleFetchTeamAccounts,
    initialLoading,
    loading,
    state,
    teamAccounts,
  };
};
